import { render, staticRenderFns } from "./BodyAnatomyCard.vue?vue&type=template&id=40355768&"
import script from "./BodyAnatomyCard.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports